import React from 'react';


function Login() {
    // const [isLoggedIn, setIsLoggedIn] = useState(false);
  
    // const handleLoginClick = () => {
    //   // 在此處調用 LIFF SDK 來取得使用者資訊，並且將 isLoggedIn 設為 true。
    //   setIsLoggedIn(true);
    // };
  
    return (
      <div>
        {/* {isLoggedIn ? (
          <p>您已經登錄成功！</p>
        ) : (
            <p>您尚未登錄。</p>
        )} */}
      </div>
    );
  }

export default Login;


// WEBPACK FOOTER //
// ./src/login.js